import { storeChanged, findSelectedAddress } from './addressUtility';

export default class ReadOnlyAddressObserver {
	constructor(storeInstance) {
		storeInstance.subscribe(this.storeChanged.bind(this));
	}

	storeChanged(event) {
		storeChanged(event, this.applyAddress.bind(this, event));
	}

	applyAddress(address) {
		const selectedAddress = findSelectedAddress(address.newValue);

		if (selectedAddress) {
			this.getFields().forEach(field =>
				this.replaceNewFieldValue(selectedAddress, field),
			);
		}
	}

	getFields() {
		return [
			'contactName',
			'companyName',
			'line1',
			'line2',
			'postalCode',
			'town',
			'currentCountry',
			'phone',
			'desktopDeliveryMessage',
			'deliveryUpdatesOptIn',
		];
	}

	replaceNewFieldValue(address, field) {
		const element = document.querySelector(`[data-address-part="${field}"]`);

		if (
			typeof field !== 'string' ||
			typeof address !== 'object' ||
			(typeof address === 'object' && address instanceof Array) ||
			!element ||
			typeof element !== 'object'
		) {
			return;
		}

		element.innerHTML = address[field];

		return element.innerHTML;
	}
}
